import React, { lazy, Suspense } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import Auth from '../../../../Layout/Auth'
import WorkInProgress from '../../../../GlobalModules/Utility/Components/WorkInProgress'
import BookingList from '../Pages/BookingList'
import CalendarView from '../Pages/CalendarView'

function Loading() {
  return (
    <>
      <div className='wrapper'>
        <span>Loading</span>
      </div>
    </>
  )
}

function CalendarRoute() {
  const history = useHistory()

  return (
    <Switch>
      <Route
        exact
        path='/:lng/calendar'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <CalendarView history={history} />
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/calendar/bookings'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <BookingList history={history} />
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/calendar/booking/view/:slack'
        render={() => <WorkInProgress />}
      />
      <Route
        exact
        path='/:lng/calendar/booking/edit/:slack'
        render={() => <WorkInProgress />}
      />
      <Route path='/:lng/calendar/:unknown' render={() => <WorkInProgress />} />
    </Switch>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(CalendarRoute)
